export default __webpack_public_path__ + "static/media/share.eb114965.svg";